import type { IPascoRepository } from "@src/domain/pascos/repository/pasco_repository";
import type { PascoDTO } from "../dto";
import { PascoDtoMapper } from "../mappers/pasco-dto.mapper";

/**
 * Use Case: Schedule Review PASCO
 * Marks a PASCO record for review
 */
export class ScheduleReviewPascoUseCase {
    constructor(private readonly pascoRepository: IPascoRepository) { }

    /**
     * Execute the use case
     * @param pascoId - The unique identifier of the PASCO to schedule for review
     * @returns Promise<PascoDTO> - The PASCO DTO marked for review
     * @throws Error if pascoId is invalid
     */
    async execute(pascoId: string): Promise<PascoDTO> {
        if (!pascoId || pascoId.trim() === '') {
            throw new Error('PASCO ID is required');
        }

        const pasco = await this.pascoRepository.scheduleReview(pascoId);
        return PascoDtoMapper.toDTO(pasco);
    }
}